<template>
  <div class="container bg-black py-5">
    <RouterLink
      class="fs-3 d-block navbar-brand link-light my-2 lh-1 text-center text-warning font-Bangers"
      to="/"
    >
      GRANDMA SAM DINER
      <p class="fw-lighter fs-6 lh-1 mb-0 text-center text-warning font-Bangers">
        LET MAKE AMERICA GREAT AGAIN
      </p>
    </RouterLink>
    <div class="container mt-3">
      <div class="row row-cols-1 row-cols-lg-2 justify-content-lg-between mt-2">
        <div class="col col-lg-6 text-light d-flex justify-content-center">
          <div class="footer-content">
            <h4 class="my-3 fw-bold font-Bangers text-center">聯絡我們</h4>

            <div
              class="d-flex justify-content-center"
              style="letter-spacing: 20px; font-size: 20px; line-height: 2rem"
            >
              <a
                class="link text-decoration-none ps-3"
                href="https://www.hexschool.com/?msclkid=8598b4ccaa4811ec81331512bb3bc247"
                ><i class="bi bi-facebook link-light text-warning"></i
              ></a>
              <a
                class="link text-decoration-none"
                href="https://www.hexschool.com/?msclkid=8598b4ccaa4811ec81331512bb3bc247"
                ><i class="bi bi-instagram link-light text-warning"></i>
              </a>
              <a
                class="link text-decoration-none"
                href="https://www.hexschool.com/?msclkid=8598b4ccaa4811ec81331512bb3bc247"
                ><i class="bi bi-twitter link-light text-warning"></i
              ></a>
            </div>
            <div class="d-flex">
              <ul class="list-unstyled text-light ms-sm-5">
                <li class="small fw-light my-1 text-nowrap">
                  <i class="bi bi-building text-warning pe-1"></i> 公司: 山姆大嬸餐飲投機無限公司
                </li>
                <li class="small fw-light my-1 text-nowrap">
                  <i class="bi bi-telephone-inbound link text-warning pe-1"></i>
                  <a href="#" alt="diner_book_tel" class="text-decoration-none link-light">
                    訂位服務專線: ( 0204 ) 5487487</a
                  >
                </li>
                <li class="small fw-light my-1 text-nowrap">
                  <i class="bi bi-phone text-warning pe-1"></i>
                  <a href="#" alt="diner_office" class="text-decoration-none link-light">
                    電話: ( 02 ) 2311 3731</a
                  >
                </li>
                <li class="text-muted small text-nowrap">註3: 請謹慎播打，該電話直達台灣領導</li>
                <li class="small fw-light my-1 text-nowrap">
                  <i class="bi bi-cursor text-warning pe-1"></i>
                  <a
                    href="https://goo.gl/maps/zZZryo7weMvN7RGo8"
                    alt="diner_office"
                    class="text-decoration-none link-light"
                  >
                    地址: 100台北市中正區中山南路21號</a
                  >
                </li>
                <li class="small fw-light my-1 text-nowrap">
                  <i class="bi bi-clock text-warning pe-1"></i> 營業時間: 24 hrs
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col col-lg-6 text-light px-lg-5">
          <div class="d-flex justify-content-center">
            <div class="footer-content">
              <h4 class="my-3 fw-bold text-center text-lg-start font-Bangers">關於作品</h4>
              <div class="p-3" style="outline: 0.5px solid gray">
                <p class="mt-2 small fw-light" style="text-indent: 8px">
                  此網頁並非商業使用，僅作為個人學習、娛樂以及六角作業繳交使用，若需要引用或作為商業用途，請先諮詢六角學院
                </p>
                <p class="text-muted small">註1: 同為繳交作業的六角同儕除外</p>
                <p class="text-muted small">註2: 若行為者是他牌補習班，則適用此限制範疇 (◐‿◑)</p>
                <p class="small fw-light">
                  此作內容全是杜撰，也無任何隱射之意，若有雷同處純屬巧合，若有冒犯之處還請海函
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="text-center text-light mt-2">
      Copyright © 2022 Grandma-Sam-Diner. All rights reserved.
    </p>
    <p class="text-muted text-center text-light small">版權所有，翻印舅舅 ( 一位很愛翻印的舅舅 )</p>
  </div>
</template>

<style>
/* * {
  outline: 1px solid white;
} */
</style>
